import { createEntityAdapter } from "@ngrx/entity";
import { Report } from "src/app/api/models/report.model";

export const reportsAdapter = createEntityAdapter<Report>();